var _g, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-297.9 391 18.4 12.8",
    enableBackground: "new -297.9 391 18.4 12.8",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("path", {
    display: "inline",
    d: "M-281,397c0,0-3-5.5-8-5.5s-8,5.5-8,5.5s3,5.5,8,5.5S-281,397-281,397z M-295.8,397c0.5-0.7,1-1.4,1.7-2 c1.3-1.3,3-2.5,5.2-2.5c2.1,0,3.9,1.2,5.2,2.5c0.6,0.6,1.2,1.3,1.7,2c-0.1,0.1-0.1,0.2-0.2,0.3c-0.3,0.5-0.8,1.1-1.5,1.8 c-1.3,1.3-3,2.5-5.2,2.5c-2.1,0-3.9-1.2-5.2-2.5C-294.8,398.4-295.3,397.7-295.8,397L-295.8,397z"
  }), /*#__PURE__*/React.createElement("path", {
    display: "inline",
    d: "M-289,394.5c-1.4,0-2.5,1.1-2.5,2.5s1.1,2.5,2.5,2.5c1.4,0,2.5-1.1,2.5-2.5S-287.6,394.5-289,394.5z  M-292.5,397c0-1.9,1.6-3.5,3.5-3.5c1.9,0,3.5,1.6,3.5,3.5c0,1.9-1.6,3.5-3.5,3.5C-290.9,400.5-292.5,398.9-292.5,397z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-288.5,403.8L-288.5,403.8c-4.1-0.1-6.7-2.9-9-5.8l-0.5-0.6l0.4-0.6c0.2-0.2,4-6.1,8.8-5.8c4.7,0.3,8.5,5.5,8.7,5.7 l0.5,0.6l-0.5,0.6C-280.5,398.6-284.7,403.8-288.5,403.8z M-295.3,397.3c2.2,2.8,4.1,4.3,6.8,4.4l0,1.1v-1.1c2,0,4.9-2.8,6.2-4.4 c-1.1-1.3-3.8-4-6.6-4.2C-291.4,392.9-294.1,395.7-295.3,397.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-288.7,400c-1.4,0-2.6-1.1-2.6-2.6c0-1.4,1.1-2.6,2.6-2.6c1.4,0,2.6,1.1,2.6,2.6C-286.2,398.8-287.3,400-288.7,400z  M-288.7,396.6c-0.5,0-0.8,0.4-0.8,0.8c0,0.5,0.4,0.8,0.8,0.8s0.8-0.4,0.8-0.8C-287.9,397-288.3,396.6-288.7,396.6z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.6135d708.svg";
export { ForwardRef as ReactComponent };